 
                @switch (task.type){
                    @case ('topic'){
                        <div class="timeline-item-badge">{{'topic' | translate }}</div>
                    }
                    @case ('question'){
                        <div class="timeline-item-badge">{{'topic.question' | translate }}</div>
                    }
                    @case ('issue'){
                        <div class="timeline-item-badge">{{'topic.issue' | translate }}</div>
                    }
                }
        
                <div class="card-top" >
                    <div class="pt-2 pe-2">
                        <i class="fa-light fa-messages-question fa-2x ms-2 pt-1 position-relative"></i>
                    </div>
                    <div class="card-comment p-3">
                        <span class="card-comment-body fst-italic" [innerHtml]="$safeNavigationMigration(task.title.body) | removeGifUrls: $safeNavigationMigration(task.title.linkPreviews) | linky"></span>
                        @for (linkPreview of task.title.linkPreviews; track linkPreview.url){
                            @if(linkPreview.url.slice(-4) === '.gif'){
                                <tm-gif-preview [gifPreview]="toGifPreview(linkPreview)"></tm-gif-preview>
                            }
                        }
                    </div>
                    <div class="card-options">
                        <div data-cy="report-comment" (click)="reportItem()">
                            <i class="fa-regular fa-hexagon-exclamation"
                               [matTooltip]="'comment-card.options.report' | translate"
                               matTooltipPosition="right"></i>
                        </div>
                    </div>
                </div>
        
                <div>
                    @for(linkPreview of task.title.linkPreviews; track linkPreview.url){
                        @if(linkPreview.url.slice(-4) !== '.gif'){
                            <div>
                                <tm-link-preview [linkPreview]="linkPreview"></tm-link-preview>
                            </div>
                        }
                    }
                </div>
        
              